import authorizedFetch from "../utilities/authorizedFetch";
import { BASE_URL } from "../config/constants";

const endpointURL = `${BASE_URL}/question`;

export const list = () => {
  return authorizedFetch(`${endpointURL}/list`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    }
  });
};

export const create = () => {
  return authorizedFetch(`${endpointURL}/list`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    }
  });
};



// WEBPACK FOOTER //
// ./src/api/question.js